import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=6516c918&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=6516c918&prod&lang=css"
import style1 from "./teacher.vue?vue&type=style&index=1&id=6516c918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6516c918",
  null
  
)

export default component.exports